import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RequestType, elapsed, initFetchObservable, initXhrObservable, timeStampNow } from '@datadog/browser-core';
import { isAllowedRequestUrl } from './resource/resourceUtils';
import { startTracer } from './tracing/tracer';
import { findGraphQlConfiguration } from './resource/graphql';
var nextRequestIndex = 1;
export function startRequestCollection(lifeCycle, configuration, sessionManager, userContext, accountContext) {
  var tracer = startTracer(configuration, sessionManager, userContext, accountContext);
  trackXhr(lifeCycle, configuration, tracer);
  trackFetch(lifeCycle, configuration, tracer);
}
export function trackXhr(lifeCycle, configuration, tracer) {
  var subscription = initXhrObservable(configuration).subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceXhr(context, context.xhr);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, _objectSpread(_objectSpread({}, context), {}, {
          type: RequestType.XHR,
          isAbortedOnStart: false
        }));
        break;
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}
export function trackFetch(lifeCycle, configuration, tracer) {
  var subscription = initFetchObservable({
    responseBodyAction: function responseBodyAction(context) {
      var _a;
      if ((_a = findGraphQlConfiguration(context.url, configuration)) === null || _a === void 0 ? void 0 : _a.trackResponseErrors) {
        return 2 /* ResponseBodyAction.COLLECT */;
      }
      return 1 /* ResponseBodyAction.WAIT */;
    }
  }).subscribe(function (rawContext) {
    var _a;
    var context = rawContext;
    if (!isAllowedRequestUrl(context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceFetch(context);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'resolve':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, _objectSpread(_objectSpread({}, context), {}, {
          duration: elapsed(context.startClocks.timeStamp, timeStampNow()),
          type: RequestType.FETCH,
          requestBody: (_a = context.init) === null || _a === void 0 ? void 0 : _a.body
        }));
        break;
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}
function getNextRequestIndex() {
  var result = nextRequestIndex;
  nextRequestIndex += 1;
  return result;
}